export enum XrayTab {
  FileMetadata = 'file-metadata',
  Metadata = 'metadata',
  Font = 'font',
  Size = 'size',
  TextBreakups = 'text-breakups',
  ActiveFields = 'active-fields',
  FontDescriptors = 'font-descriptors',
  ByteCode = 'byte-code',
  SimilarDocuments = 'similar-documents'
}

export enum XrayTabGroup {
  Metadata = 'metadata',
  TextProperties = 'text-properties',
  FontDescriptors = 'font-descriptors',
  ByteCode = 'byte-code',
  SimilarDocuments = 'similar-documents'
}
